webpackJsonp([241038700911720],{

/***/ 1667:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BillingGroupOption","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":"Minimal billing group info for dropdowns (no permission required)","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-billing-group-option-7caa50ed758188a4dbf4.js